import type { Severity } from './types';

/**
 * D3/Recharts render raw SVG attributes, so they can't consume Tailwind classes or `var(--x)` the
 * way the rest of the app does. These mirror styles/tokens.css's `--severity-*`/`--brand-primary`
 * values exactly (same mapping everywhere: BUI Dual-Theme brief Section 16) for each resolved
 * theme — pick the right one via `useTheme()`'s `resolved` so charts recolor immediately on a
 * theme switch instead of needing a page reload. Shared by AttackPaths' D3 graph and the
 * Dashboard's Recharts widgets so both stay in sync with one source of truth.
 */
export const SEVERITY_COLOR_BY_THEME: Record<'light' | 'dark', Record<Severity, string>> = {
  dark: { critical: '#e5484d', high: '#f2703c', medium: '#f0b54a', low: '#61a8f8', info: '#768494' },
  light: { critical: '#c2333b', high: '#c85a1e', medium: '#a96900', low: '#246fc7', info: '#7b8997' },
};

export const BRAND_COLOR_BY_THEME: Record<'light' | 'dark', string> = {
  dark: '#f47a17',
  light: '#e96f0e',
};

export const CHART_NEUTRAL_BY_THEME: Record<'light' | 'dark', { grid: string; axis: string; surface: string }> = {
  dark: { grid: '#293542', axis: '#a9b4c1', surface: '#10161e' },
  light: { grid: '#e5e9ee', axis: '#536170', surface: '#ffffff' },
};
